module.exports = __webpack_public_path__ + "res/Roboto-Condensed-webfont.woff?6ca78e7e85afc3c94b712de8019f5892";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Condensed-webfont.woff
// module id = 38
// module chunks = 0